import { initElements } from "../../define/shared";

export function initGridLinksBlock() {
    initElements(".gridLinks", (block) => {
        // This solves the issue with vertical spacing in css-grid layout.
        // The issue is that value in percentage is calculated from pre-gap height
        // causing the total height be larger and content to overflow.

        // Spacing as a percentage of the column width, converted to a decimal.
        const spacing = (parseInt(block.dataset.spacing) || 0) / 100;
        const numColumns = parseInt(block.dataset.numColumns) || 1;

        if (!spacing) {
            return;
        }

        function recalcSpacing() {
            const pxSpacing = spacing * (block.offsetWidth / numColumns);
            block.style.setProperty('--gap', pxSpacing + 'px', 'important');
        }

        recalcSpacing();
        window.addEventListener("resize", recalcSpacing);
        window.addEventListener("orientationchange", recalcSpacing);
    });
}
